import { render, staticRenderFns } from "./infoIcons.vue?vue&type=template&id=e0987dc2&scoped=true"
import script from "./infoIcons.vue?vue&type=script&lang=js"
export * from "./infoIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0987dc2",
  null
  
)

export default component.exports